import React from 'react'

import { shape, string, arrayOf, bool } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import DropdownItem from './Components/DropdownItem/DropdownItem'

function DropdownSection({ heading = '', items = EMPTY_ARRAY, divided = false }) {
  return (
    <div
      className={`unified-nav__dropdown-section${divided ? ' unified-nav__dropdown-section--divided' : ''}`}
    >
      <p className="unified-nav__dropdown-heading cgt-overline-md">{heading}</p>
      <ul className="unified-nav__dropdown-list">
        {items.map((item) => (
          <DropdownItem key={item.trackText} {...item} />
        ))}
      </ul>
    </div>
  )
}

DropdownSection.propTypes = {
  heading: string,
  items: arrayOf(shape({
    title: string,
    href: string,
    icon: string,
    trackText: string,
  })),
  divided: bool,
}

export default DropdownSection
